import { render, staticRenderFns } from "./ConfirmUserDelete.vue?vue&type=template&id=d37c081a&scoped=true&"
import script from "./ConfirmUserDelete.vue?vue&type=script&lang=js&"
export * from "./ConfirmUserDelete.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUserDelete.vue?vue&type=style&index=0&id=d37c081a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37c081a",
  null
  
)

export default component.exports